import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { timeSlotService } from "../../services/timeSlot.service";
import Notification from "../common/Notification";
import UserMenu from "../common/UserMenu";
import AuthContext from "../../store/auth-context";
import { bookAppointmentService } from "../../services/bookAppointment.service";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import AppointmentBooked from "./AppointmentBooked";
import moment from "moment";
import { useTranslation } from "react-i18next";

function BookApptFromPast() {
  const [beginDate, setBeginDate] = useState<any>(
    new Date().toISOString().slice(0, 10)
  );
  const [t] = useTranslation();
  const [morningSlots, setMorningSlot] = useState<any>([]);
  const [afternoonSlots, setAfternoonSlot] = useState<any>([]);
  const [eveningSlots, setEveningSlot] = useState<any>([]);
  const [futureDates, setFutureDates] = useState<any>([]);
  const [timeSlot, setTime] = useState<any>("");
  const [patientName, setPatientName] = useState<any>("");
  const [timeItem, setTimeItem] = useState<any>("");
  const authCtx = useContext(AuthContext);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("");
  const [appointmentBookedModal, setAppointBookedModal] =
    useState<boolean>(false);
  const [familyMemberList, setFamilyMemberList] = useState<any>([]);
  const [familyMemberId, setFamilyMemberId] = useState<any>(null);
  const [isValidUser, setIsValidUser] = useState<boolean>(true);
  const [bookingConfirmation, setBookingConfirmation] =
    useState<boolean>(false);
  const [valetParkng, setValetParking] = useState<boolean>(false);
  const [apptRefNumber, setAppointmentRefNo] = useState<string>("");
  const [timeSlotErrorMessage, setTimeSlotErrorMessage] = useState<string>("");

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  let location = useLocation();
  let value: any = location.state;
  let doctorValue: any = value.item;

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    setFamilyMemberId(value.fmId);
    setPatientName(user.firstName + " " + user.lastName);
    const fetchTime = () => {
      fetchTimeSlot();
    };
    fetchTime();

    const getFamilyList = async () => {
      fetchFamilyMember();
    };
    getFamilyList();
    // eslint-disable-next-line
  }, [beginDate]);

  const fetchFamilyMember = async () => {
    const familyMembers = JSON.parse(
      localStorage.getItem("familyMemberList") || "[]"
    );
    setFamilyMemberList(familyMembers);
  };

  const handleDateChange = (e: any) => {
    setBeginDate(e.target.value);
    setTime("");
  };

  const fetchTimeSlot = async () => {
    authCtx.toggleLoader(true);
    const patientRecord = JSON.parse(
      localStorage.getItem("getPatientRecord") || "{}"
    );
    let timeData: any = {};
    timeData = {
      facilityId: doctorValue.facilityId,

      department: doctorValue.department,

      physicianLicense: doctorValue.physicianLicense,

      physicianNo: doctorValue.physicianNo,

      providerLicence: "",

      beginDate: beginDate,

      endDate: "",
      patientId:
        Object.keys(patientRecord).length !== 0 &&
        patientRecord[0].patientId[0] !== ""
          ? patientRecord[0].patientId[0]
          : "",
    };
    // authCtx.toggleLoader(false);
    let result = await timeSlotService.getTimeSlot(timeData);
    if (result && result.status === 500) {
      console.log(result.message);
    } else {
      if (
        result &&
        result.morningSlots.length === 0 &&
        result.afternoonSlots.length === 0 &&
        result.eveningSlots.length === 0 &&
        result.futureDates.length === 0 &&
        result.message &&
        result.message.message &&
        result.message.message[0] ===
          "Please call on +971-80055 for booking an appointment."
      ) {
        setTimeSlotErrorMessage(
          t("Please call on +971-80055 for booking an appointment.")
        );
      } else if (
        result.morningSlots.length >= 0 &&
        result.afternoonSlots.length >= 0 &&
        result.eveningSlots.length >= 0 &&
        result.futureDates.length >= 0
      ) {
        setMorningSlot(result.morningSlots);
        setAfternoonSlot(result.afternoonSlots);
        setEveningSlot(result.eveningSlots);
        setFutureDates(result.futureDates);
        setTimeSlotErrorMessage("");
      }
    }
    authCtx.toggleLoader(false);
  };

  const hanldeTimeChange = (e: any, timeItem: any) => {
    setTime(e.target.value);
    setTimeItem(timeItem);
  };

  const handleFamilyChange = (e: any) => {
    if (e.target.value === user.firstName + " " + user.lastName) {
      setPatientName(user.firstName + " " + user.lastName);
      setFamilyMemberId(null);
    } else {
      setFamilyMemberId(Number(e.target.value));

      let familMember = familyMemberList.find(
        (item: any) => item.familyMemberId === Number(e.target.value)
      );
      let patientName = familMember.firstName + " " + familMember.lastName;
      setPatientName(patientName);
    }
  };

  function checkEmirateId() {
    let isValid: boolean = true;
    const userData: any = authCtx.userProfileDetails;
    if (userData.documentTypeId === 1) {
      const emirateId = userData.documentId;
      const dobYear = moment(userData.dateOfBirth, "YYYY-MM-DD").format("YYYY");
      const compereCodeWith =
        "784" + dobYear + emirateId.toString().slice(7, emirateId.length);
      if (emirateId !== compereCodeWith) {
        isValid = false;
      }
    }
    return isValid;
  }

  const confirmBooking = async () => {
    let data: any;
    if (familyMemberId !== 0 && familyMemberId !== null) {
      let familMember = familyMemberList.find(
        (item: any) => item.familyMemberId === familyMemberId
      );
      if (familMember.age > 18) {
        if (
          familMember.mobile === user.mobile &&
          familMember.callingCode === user.callingCode
        ) {
          setShowModal(true);
          setModalType("error");
          setModalText(
            t(
              "As per our privacy policies an adult requires a different number. Please use a different number."
            )
          );
          setIsValidUser(false);
        }
      }
    }

    if (checkEmirateId()) {
      if (isValidUser) {
        authCtx.toggleLoader(true);
        data = {
          facilityId: doctorValue.facilityId,

          apptDate: timeItem.date,
          apptStartTime: timeItem.startTime,
          apptEndTime: timeItem.endTime,
          patientId: user.userId,
          familyMemberId: familyMemberId,
          callpoint: "",
          department: timeItem.department,
          physicianNo: timeItem.physicianNo,
          physicianLicense: timeItem.physicianLicense,
          scheduleType: "ONLINE",
          comment: "",
          title: "Mr",
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          dateOfBirth: "",
          genderId: 0,
          identityNumber: "",
          mobileNo: user.mobile,
          nationality: "",
          countryId: user.countryCode,
          documentTypeId: 0,
          identityDocExpiryDate: "",
          patientLang: "",
          occupation: "",
          bloodGroup: "",
          externalPatientId: "",
          country: "",
          city: "",
          region: "",
          streetNumber: "",
          postOfficeBox: "",
          kinFirstName: "",
          kinLastName: "",
          kinCountry: "",
          kinTelephone: "",
          kinRelationship: "",
        };

        const response = await bookAppointmentService.bookAppointment(data);
        authCtx.toggleLoader(false);
        if (
          response &&
          response.data &&
          response.data.appointmentRefNo === null
        ) {
          if (response.message.message && response.message.status[0] === "E") {
            handleShow();
            setModalText(response.message.message[0]);
            setModalType("error");
            setTimeout(() => {
              setModalText("");
              handleClose();
            }, 3000);
          } else {
            handleShow();
            setModalText(t("Something went wrong!"));
            setModalType("error");
            setTimeout(() => {
              setModalText("");
              handleClose();
            }, 3000);
          }
        } else {
          setAppointmentRefNo(response.data.appointmentRefNo);
          setAppointBookedModal(true);
          if (familyMemberId === 0) {
            localStorage.setItem("isPatientRecordCall", "false");
          }
        }
      }
    } else {
      handleShow();
      setModalText(t("Invalid Emirates Id or date of birth"));
      setModalType("error");
      setTimeout(() => {
        setModalText("");
        handleClose();
      }, 5000);
    }
  };

  const toggleValetParking = () => {
    setValetParking(!valetParkng);
  };

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>
          <h3 className="fs-18-24">{t("Book Appointment")}</h3>
          <div
            className={`${
              authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
            } mw-90px`}
          >
            <Notification />
            <UserMenu />
          </div>
        </div>
        <div className="row">
          <div className="col-md-7">
            <div
              className={`card border-0 shadow-sm rounded-1rem ${
                timeSlotErrorMessage ? "mh-500p" : ""
              }`}
            >
              <div className="card-body p-4">
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    {" "}
                    <img
                      src={doctorValue && doctorValue.image}
                      className="img-h-75  rounded-circle dr-photo"
                      alt="dr-img"
                    />{" "}
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h6 className="fw-bold mt-0 mb-1">
                      {doctorValue && doctorValue.physicianName}
                    </h6>
                    <p className="fw-bold text-muted mb-1">
                      {doctorValue && doctorValue.specialty}
                    </p>
                    <p className="text-muted mb-1">
                      {doctorValue && doctorValue.experience}
                    </p>
                    <p className="text-muted mb-1">
                      {doctorValue && doctorValue.location}
                    </p>
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    style={{ backgroundColor: "white" }}
                    className=" ms-auto text-dark border-0 pt-1 float-end"
                    onClick={() => {
                      let date = new Date(beginDate);
                      date.setDate(date.getDate() + 1);
                      let newDate = date.toISOString().slice(0, 10);
                      setBeginDate(newDate);
                      setTime("");
                    }}
                  >
                    <i className="material-icons-outlined">
                      {" "}
                      {authCtx.selectedLanguage === "en"
                        ? "chevron_right"
                        : "chevron_left"}
                    </i>
                  </button>
                  <button
                    style={{
                      pointerEvents:
                        beginDate === new Date().toISOString().slice(0, 10)
                          ? "none"
                          : "auto",
                      backgroundColor: "white",
                    }}
                    className="text-dark border-0 pt-1 float-end"
                    onClick={() => {
                      let date = new Date(beginDate);
                      date.setDate(date.getDate() - 1);
                      let newDate = date.toISOString().slice(0, 10);
                      setBeginDate(newDate);
                      setTime("");
                    }}
                  >
                    <i className="material-icons-outlined">
                      {" "}
                      {authCtx.selectedLanguage === "en"
                        ? "chevron_left"
                        : "chevron_right"}
                    </i>
                  </button>
                  <label className="fw-bold mb-1 mt-1">
                    {t("choose_date")}
                  </label>

                  <input
                    type="date"
                    className="form-control fs-14 no-focus"
                    id="slotDate"
                    value={beginDate}
                    onChange={(e) => handleDateChange(e)}
                    min={new Date().toISOString().slice(0, 10)}
                  />
                </div>
                {timeSlotErrorMessage ? (
                  <div className="text-999 mt-4">
                    <i className="material-icons-outlined fs-3 me-2">info</i>
                    <span className="position-relative t-n10">
                      {t(timeSlotErrorMessage)}
                    </span>
                  </div>
                ) : (
                  <div className="fs-12 mt-4 border-top pt-4">
                    <h6 className="mb-4 fs-14">
                      {t("Showing slots for")}
                      <span className="fw-bold">
                        {" "}
                        {new Date(beginDate).toLocaleString("en-uk", {
                          weekday: "long",
                          day: "2-digit",
                          year: "numeric",
                          month: "short",
                        })}
                      </span>
                    </h6>
                    <div className="mb-3">
                      <h6 className="fs-12">{t("Morning")}</h6>
                      {morningSlots.length > 0 ? (
                        morningSlots.map((timeItem: any, index: any) => (
                          <>
                            <input
                              key={index}
                              type="radio"
                              className="btn-check no-focus"
                              name="Morning"
                              id={timeItem.slNo}
                              value={timeItem.text}
                              checked={timeSlot === timeItem.text}
                              onChange={(e) => hanldeTimeChange(e, timeItem)}
                            />

                            <label
                              key={timeItem.slNo}
                              className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                              htmlFor={timeItem.slNo}
                              dir="ltr"
                            >
                              {timeItem.text}
                            </label>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="text-999">
                            <i className="material-icons-outlined fs-3 me-2">
                              info
                            </i>
                            <span className="position-relative t-n10">
                              {t("No Available Slot")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="mb-3">
                      <h6 className="fs-12">{t("Afternoon")}</h6>
                      {afternoonSlots.length > 0 ? (
                        afternoonSlots.map((timeItem: any, index: any) => (
                          <>
                            <input
                              key={index}
                              type="radio"
                              className="btn-check no-focus"
                              name="Morning"
                              id={timeItem.slNo}
                              value={timeItem.text}
                              checked={timeSlot === timeItem.text}
                              onChange={(e) => hanldeTimeChange(e, timeItem)}
                            />

                            <label
                              key={timeItem.slNo}
                              className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                              htmlFor={timeItem.slNo}
                              dir="ltr"
                            >
                              {timeItem.text}
                            </label>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="text-999">
                            <i className="material-icons-outlined fs-3 me-2">
                              info
                            </i>
                            <span className="position-relative t-n10">
                              {t("No Available Slot")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="mb-3">
                      <h6 className="fs-12">{t("Evening")}</h6>
                      {eveningSlots.length > 0 ? (
                        eveningSlots.map((timeItem: any, index: any) => (
                          <>
                            <input
                              key={index}
                              type="radio"
                              className="btn-check no-focus"
                              name="Morning"
                              id={timeItem.slNo}
                              value={timeItem.text}
                              checked={timeSlot === timeItem.text}
                              onChange={(e) => hanldeTimeChange(e, timeItem)}
                            />

                            <label
                              key={timeItem.slNo}
                              className="btn btn-outline-primary btn-xs mb-1 me-1 fs-12 w-150 no-focus"
                              htmlFor={timeItem.slNo}
                              dir="ltr"
                            >
                              {timeItem.text}
                            </label>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="text-999">
                            <i className="material-icons-outlined fs-3 me-2">
                              info
                            </i>
                            <span className="position-relative t-n10">
                              {t("No Available Slot")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="mb-3">
                      <h6 className="fs-12">{t("Next Available Dates")}</h6>
                      {futureDates && futureDates.length > 0 ? (
                        futureDates.map((futureItem: any, index: any) => (
                          <button
                            key={index}
                            className="btn btn-outline-success btn-xs mb-1 me-1 fs-12k w-185 no-focus"
                            onClick={() => {
                              setBeginDate(futureItem);
                              setTime("");
                            }}
                            dir="ltr"
                          >
                            {new Date(futureItem).toLocaleString("en-uk", {
                              weekday: "short",
                              day: "2-digit",
                              year: "numeric",
                              month: "short",
                            })}
                          </button>
                        ))
                      ) : (
                        <>
                          <div className="text-999">
                            <i className="material-icons-outlined fs-3 me-2">
                              info
                            </i>
                            <span className="position-relative t-n10">
                              {t("No Available slots for next 30 days")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-5 mt-4 mt-md-0">
            <div className="card border-0 shadow-sm rounded-1rem position-sticky top-0">
              <div className="card-body">
                <div className="mt-2">
                  <select
                    className="form-select fs-14 no-focus"
                    id="selectPatient"
                    onChange={(e) => handleFamilyChange(e)}
                    value={familyMemberId}
                  >
                    <option value={user.firstName + " " + user.lastName}>
                      {user.firstName} {user.lastName}
                    </option>
                    {familyMemberList &&
                      familyMemberList.map((item: any, index: any) => (
                        <option key={index} value={item.familyMemberId}>
                          {item.firstName} {item.lastName} ({item.relation})
                        </option>
                      ))}
                  </select>
                </div>
                <div className="mt-4">
                  <label className="fw-bold mb-2">{t("Timing")}</label>
                  {timeSlot ? (
                    <p
                      className={`fs-14 m-0 ${
                        authCtx.selectedLanguage === "en" ? "" : "text-start"
                      }`}
                      dir="ltr"
                    >
                      {timeSlot}, {new Date(beginDate).toDateString()}
                    </p>
                  ) : (
                    <p className="fs-14 m-0">--:--</p>
                  )}
                </div>
                <div className="mt-4">
                  <label className="fw-bold mb-2">
                    {t("Address")}
                    <Link
                      className="position-relative ms-1 t-5"
                      to={{
                        pathname: `https://www.google.com/maps/dir//${
                          doctorValue && doctorValue.location
                        }`,
                      }}
                      target="_blank"
                    >
                      {" "}
                      <i className="material-icons-outlined"> near_me </i>{" "}
                    </Link>
                  </label>
                  <p className="fs-14 m-0">
                    {doctorValue && doctorValue.location}
                  </p>
                </div>
                <button
                  className="btn btn-primary mt-3 w-100"
                  onClick={() => setBookingConfirmation(true)}
                  disabled={timeSlot === ""}
                >
                  {t("Confirm Booking")}
                </button>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={appointmentBookedModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <AppointmentBooked
            appointmentDoctor={[doctorValue]}
            timeSlot={timeSlot}
            timeItem={timeItem}
            beginDate={beginDate}
            patientName={patientName}
            appointmentText={"Appointment Booked"}
            book={"Re-Book"}
            apptRefNumber={apptRefNumber}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={bookingConfirmation}
        onClose={() => setBookingConfirmation(false)}
      >
        <DialogTitle>{t("Appointment Confirmation")}</DialogTitle>
        <DialogContent>
          <div className="card-body p-4  ln-24">
            <div className="d-flex ">
              <div className="flex-shrink-0">
                {" "}
                <img
                  src={doctorValue.image}
                  alt="img"
                  className="img-h-75 rounded-circle dr-photo"
                />{" "}
              </div>
              <div className="flex-grow-1 ms-3">
                <label className="fw-bold">{doctorValue.physicianName}</label>
                <p className="text-muted fs-12 m-0">
                  {new Date(
                    "1970-01-01T" + timeItem.startTime + "Z"
                  ).toLocaleTimeString("en-US", {
                    timeZone: "UTC",
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                  })}{" "}
                  | {new Date(beginDate).toDateString()}
                </p>
                <p className="text-muted fs-12 m-0">{doctorValue.location}</p>
                <p className="text-muted fs-12 m-0">
                  {t("For")} <span className="fw-bold"> {patientName}</span>
                </p>
              </div>
            </div>
          </div>
          <DialogContentText>
            {/* <div className="mb-2 form-check">
            <input
              type="checkbox"
              className="form-check-input no-focus"
              id="agree"
              onChange={toggleValetParking}
            />
            <label className="form-check-label fw-bold fs-14" htmlFor="agree">
                Do you want valet parking?
            </label>
          </div> */}
            {t("Are you sure you want to book an appointment?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-primary"
            onClick={() => setBookingConfirmation(false)}
          >
            {t("No")}
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              confirmBooking();
              setBookingConfirmation(false);
            }}
          >
            {t("Yes")}
          </button>
        </DialogActions>
      </Dialog>

      {modalType === "error" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          open={showModal}
          onClose={() => {
            handleClose();
            setModalText("");
          }}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default BookApptFromPast;
